export { default as General } from 'subaccounts/components/form/sections/SubaccountFormGeneral';
export { default as Depreciations } from 'subaccounts/components/form/sections/SubaccountFormDepreciations';
export { default as CustomFields } from 'subaccounts/components/form/sections/SubaccountFormCustomFields';



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/form/sections/index.js